__webpack_require__.p = "https://qa-digital-category-mfe.digital.vpsvc.com/";